module.exports = __webpack_public_path__ + "img/Unidad3-1.b82c0f5f.png";